import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 *  
 * @desc List of subscription counter
 */
export function getSubscriptionCounterAction(recordPerPage,pageIndex) {  
    var url = UrlConstants.subscriptionCounterUrl.replace("{recordPerPage}", recordPerPage);
    var replacedUrl = url.replace("{pageIndex}",pageIndex);
    return function (dispatch){
      return APIUtil.getMethod(replacedUrl ,true).then(response => {
        
          if(response.status === code.OK) {
              dispatch( {
                    type: types.SUBSCRIPTION_DATA,
                    subscriptionData: response.data.data,
                    totalSubscription:response.data.total
              });
          }
          else {
              dispatch( {
                  type: types.SUBSCRIPTION_DATA,
                  subscriptionData: {},
              });
          }
          return response.data.data;
      });
    }  
}